import * as allExports from "./index.js";
import { mixin } from "./index.js";
var _ = mixin(allExports);
_._ = _;
export default _;
